// src/helpers/storageHelper.js

// ✅ Get current user
export const appUser = () => {
  const raw = localStorage.getItem("app.user");
  return raw ? JSON.parse(raw) : null;
};

// ✅ Save user
export const setAppUser = (user) => {
  localStorage.setItem("app.user", JSON.stringify(user));
};

// ✅ Remove user
export const clearAppUser = () => {
  localStorage.removeItem("app.user");
};

// ✅ Get token
export const appToken = () => localStorage.getItem("app.token") || null;

// ✅ Save token
export const setAppToken = (token) => {
  localStorage.setItem("app.token", token);
};

// ✅ Remove token
export const clearAppToken = () => {
  localStorage.removeItem("app.token");
};



// ➕ NEW: Helpers for user session
// -------------------------------

// ✅ Get user from sessionStorage
export const sessionUser = () => {
  const raw = sessionStorage.getItem("session.user");
  return raw ? JSON.parse(raw) : null;
};

// ✅ Save user to sessionStorage
export const setSessionUser = (user) => {
  sessionStorage.setItem("session.user", JSON.stringify(user));
};

// ✅ Remove user from sessionStorage
export const clearSessionUser = () => {
  sessionStorage.removeItem("session.user");
};

// ✅ Get token from sessionStorage
export const sessionToken = () => sessionStorage.getItem("session.token") || null;

// ✅ Save token to sessionStorage
export const setSessionToken = (token) => {
  sessionStorage.setItem("session.token", token);
};

// ✅ Remove token from sessionStorage
export const clearSessionToken = () => {
  sessionStorage.removeItem("session.token");
};